import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { ref } from 'vue';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';


export default /*@__PURE__*/_defineComponent({
  __name: 'TabSearch',
  props: {
    modelValue: { default: '' },
    placeholder: { default: 'Search...' }
  },
  emits: ["update:modelValue", "search"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
const emit = __emit;

const props = __props;

const inputDt = ref({
    borderRadius: '10px',
    borderColor: '#E6E9EB',
    hoverBorderColor: '#d0d5da',
    focusBorderColor: '#E6E9EB',
    paddingY: '13.5px',
    shadow: 'none',
});

function clearSearch() {
    emit('update:modelValue', '');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IconField), { class: "tab-search" }, {
    default: _withCtx(() => [
      _createVNode(_unref(InputText), {
        class: "tab-search__input",
        "model-value": props.modelValue,
        placeholder: props.placeholder,
        dt: inputDt.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event as string))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('search', props.modelValue)), ["enter"]))
      }, null, 8, ["model-value", "placeholder", "dt"]),
      (props.modelValue)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "tab-search__clear",
            "aria-label": "Clear search",
            onClick: clearSearch
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "pi pi-times",
              "aria-hidden": "true"
            }, null, -1)
          ]))]))
        : (_openBlock(), _createBlock(_unref(InputIcon), {
            key: 1,
            class: "pi pi-search tab-search__icon"
          }))
    ]),
    _: 1
  }))
}
}

})